import { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import { parseHTML } from '@/lib/parse';

import Heart, { HeartFilled } from './Heart';

const Message: FC<any> = ({ message, thread, index }) => {
	const [liked, changeLikedStatus] = useState(false);

	return (
		<Wrapper className="message-404">
			<Content className="message-404__content">
				{index === 0 && <Name>{thread.author.name}</Name>}

				<div>{parseHTML(message.content)}</div>

				<Time>{message.time}</Time>
			</Content>

			<Like $active={liked} onClick={() => changeLikedStatus(!liked)}>
				<Heart />

				<HeartFilled />
			</Like>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	margin-top: 5px;
	position: relative;
`;

const Content = styled.div`
	width: 540px;
	max-width: 100%;
	padding: 18px 20px;
	padding-bottom: 32px;
	box-sizing: border-box;
	background-color: var(--color-white-30);
	position: relative;
	border-radius: 6px 23px 23px 23px;

	@media (max-width: 530px) {
		padding-top: 15px;
		padding-bottom: 26px;
	}

	@media (max-width: 450px) {
		padding-top: 10px;
		padding-left: 16px;
		padding-right: 17px;
		padding-bottom: 28px;
	}

	p {
		font-family: var(--font-sans);

		font-size: 18px;
		line-height: 25px;
		color: var(--color-black);

		@media (max-width: 530px) {
			font-size: 15px;
			line-height: 24px;
		}
	}

	&:nth-of-type(3) {
		padding-bottom: 32px;
	}
`;

const Like = styled.div<{ $active: boolean }>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: -60px;
	width: 40px;
	height: 40px;
	background-color: var(--color-white-30);
	border-radius: 50%;
	cursor: pointer;

	&:hover {
		svg.heart-default path {
			fill: var(--color-purple) !important;
		}
	}

	svg.heart-default {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -6px;
		margin-left: -7px;
		transition: 0s;
		opacity: 1;
		width: 14px;

		path {
			transition: 0.2s;
			fill: transparent;
		}
	}

	svg.heart-filled {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -6px;
		margin-left: -7px;
		transform: scale(0);
		transition: 0s;
		width: 14px;
	}

	${({ $active }) =>
		$active &&
		css`
			svg.heart-default {
				opacity: 0;
			}

			svg.heart-filled {
				transform: scale(1);
				transition: 0.55s;
			}
		`}
`;

const Name = styled.h3`
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	color: var(--color-purple);

	@media (max-width: 530px) {
		font-size: 17px;
		line-height: 24px;
		margin-bottom: 5px;
	}
`;

const Time = styled.div`
	position: absolute;
	bottom: 8px;
	right: 20px;
	font-family: var(--font-sans);

	font-weight: var(--font-medium);
	font-size: 14px;
	line-height: 20px;
	text-align: right;
	color: var(--color-purple-50);
`;

export default Message;
